<script>
  // @ts-check
  import Button from "../atoms/Button.svelte";
  import DynamicHeading from "../atoms/DynamicHeading.svelte";
  import Grid from "../atoms/Grid.svelte";
  import GridContainer from "../atoms/GridContainer.svelte";
  import Image from "../atoms/Image.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * Additional classes which apply to the container
   * @type { string }
   * */
  let className = "";
  export { className as class };

  /**
   * The title of the hero section
   * @type {string}
   */
  export let title;

  /**
   * The subtitle of the hero section
   * @type {string}
   */
  export let subtitle = null;

  /**
   * The secondary text in the hero section.
   * @type {string}
   */
  export let secondaryText = null;

  /**
   * The call to action in the hero section
   * @type {import('../types/shared.js').CTA}
   */
  export let cta = null;

  /**
   * The featured image in the hero section
   * @type {import('../types/shared.js').Image}
   */
  export let featuredImage = null;

  const pseudoElementClass =
    "md:after:border-l-thin md:after:h-full md:after:absolute md:after:-right-grid-gutter-half md:after:top-0 md:after:w-px";
  const contentClass = featuredImage
    ? `max-md:border-b-thin max-md:pb-7.5 md:col-span-6 md:relative ${pseudoElementClass}`
    : "";
</script>

<GridContainer
  {id}
  containerElement="section"
  containerClass="bg-white text-black pt-15 pb-7.5 md:pt-20 md:pb-15 xl:pt-25"
>
  <Grid gridClass={className}>
    <div class="col-full-width flex flex-col {contentClass}">
      <div class="grow">
        <!-- Since Heroes are generally H1, we don't wrap with DynamicHeadingContext 
          to bump the heading level -->
        <DynamicHeading class="heading-lg">{title}</DynamicHeading>
        {#if subtitle}
          <p class="body-md mt-4 max-md:max-w-[600px] lg:mt-6 xl:mt-8">{subtitle}</p>
        {/if}
      </div>
      {#if secondaryText}
        <p class="heading-xs mt-4 md:mt-6 xl:mt-8">{secondaryText}</p>
      {:else if cta}
        <div class="mt-7.5 flex md:mt-6 xl:mt-8">
          <Button url={cta.url} label={cta.text} />
        </div>
      {/if}
    </div>
    {#if featuredImage}
      <div class="col-full-width max-md:mt-10 md:col-span-6">
        <Image {...featuredImage} aspectRatioClasses="aspect-1/1" />
      </div>
    {/if}
  </Grid>
</GridContainer>
